var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_713_5391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.5008 127.662C99.6597 127.662 128.162 99.1597 128.162 64.0008C128.162 28.8418 99.6597 0.339844 64.5008 0.339844C29.3418 0.339844 0.839844 28.8418 0.839844 64.0008C0.839844 99.1597 29.3418 127.662 64.5008 127.662Z",
    fill: "#2C3642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.7432 13.0547H25.7617V113.166H104.088V33.3143L83.7432 13.0547Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.7441 33.3143H104.089L83.7441 13.0547V33.3143Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M40.2578 44.25H89.5929V49.4209H40.2578V44.25Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.2578 59.7617H89.5929V64.9326H40.2578V59.7617Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.2578 75.1895H89.5929V80.3603H40.2578V75.1895Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M40.2578 90.6191H89.5929V95.79H40.2578V90.6191Z",
    fill: "#DEDEDF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.2325 90.957L69.8418 99.9425L76.0299 93.7544L73.2325 90.957Z",
    fill: "#F5EA0A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M78.8272 96.4665L76.0299 93.7539L69.8418 99.942L78.8272 96.4665Z",
    fill: "#F8B517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M74.9279 92.5664L69.8418 99.9412L77.2166 94.8552L74.9279 92.5664Z",
    fill: "#FBD303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M71.2829 96.2109L69.8418 99.9407L73.5716 98.4997L71.2829 96.2109Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M109.209 54.918L110.827 56.5361L74.8685 92.4948L73.2503 90.8766L109.209 54.918Z",
    fill: "#3EB9E3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M110.818 56.6191L113.096 58.8965L77.1371 94.8552L74.8597 92.5778L110.818 56.6191Z",
    fill: "#0090FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M113.15 58.918L114.769 60.5361L78.8099 96.4948L77.1917 94.8766L113.15 58.918Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M119.008 54.5906L115.194 50.776C114.685 50.2674 113.922 50.2674 113.413 50.776L109.26 54.9296L114.854 60.5243L119.008 56.3707C119.432 55.8621 119.432 55.0992 119.008 54.5906Z",
    fill: "#F6CEB0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M116.548 58.8281L110.869 53.1486C110.699 52.9791 110.445 52.9791 110.276 53.1486C110.106 53.3182 110.106 53.5725 110.276 53.742L115.955 59.4215C116.125 59.591 116.379 59.591 116.548 59.4215C116.633 59.2519 116.633 58.9976 116.548 58.8281Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M115.701 59.6758L110.021 53.9963C109.852 53.8268 109.597 53.8268 109.428 53.9963C109.258 54.1658 109.258 54.4201 109.428 54.5897L115.107 60.2691C115.277 60.4387 115.531 60.4387 115.701 60.2691C115.87 60.0996 115.87 59.8453 115.701 59.6758Z",
    fill: "#4F5565"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_5391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataSvg);
export default __webpack_public_path__ + "static/media/NoDataSvg.f84d983fd3ae96e51fe4e8675af3c73f.svg";
export { ForwardRef as ReactComponent };